import get from 'lodash.get'

import { UploadStatus, ResultStatus } from './constants'

const createGetUploadStatus = (type) => state => get(state, 'spreadsheet.uploadStatus', UploadStatus.IDLE) === type
const createGetResultStatus = (type) => state => get(state, 'spreadsheet.resultStatus', ResultStatus.NONE) === type

// Example of composing selectors
// Note in this case we would be better off just accessing state.user.email
// on getCurrentUserEmail since we're _technically_ not deriving any data.
// However - I just want to make sure we have examples going on here.
export const getCurrentUser = state => get(state, 'user', {})
export const getCurrentUserEmail = state => get(getCurrentUser(state), 'email', '')

export const getIsIdle = createGetUploadStatus(UploadStatus.IDLE)
export const getIsReady = createGetUploadStatus(UploadStatus.READY)
export const getIsValidating = createGetUploadStatus(UploadStatus.VALIDATING)
export const getIsUploading = createGetUploadStatus(UploadStatus.UPLOADING)

export const getIsSuccess = createGetResultStatus(ResultStatus.SUCCESS)
export const getIsError = createGetResultStatus(ResultStatus.ERROR)

export const getSpreadsheetData = state => get(state, 'spreadsheet.spreadsheetData', [])
export const getValidationData = state => get(state, 'spreadsheet.validationData', {})

export const getLastSuccessCount = state => get(state, 'spreadsheet.lastSuccessCount', 0)

export const getTotalRows = state => getSpreadsheetData(state).length
export const getInvalidRows = state => Object.keys(getValidationData(state)).length

export const getSpreadsheetInvalidDataForType = (type, state) => {
    const spreadsheetData = getSpreadsheetData(state)
    const validationData = getValidationData(state)

    return Object
        .entries(validationData)
        .reduce((acc, [key, value]) => (value.hasOwnProperty(type) && !(value[type]) ? acc.concat([spreadsheetData[key]]) : acc), [])
}
